var _radialGradient, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLightroom = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 130.746 595.279 580.398",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: -183.69,
    cy: 328.972,
    r: 0.76,
    gradientTransform: "matrix(545.6736 0 0 528.3113 100439.305 -173525.125)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39464d",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05151f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.803 155.549h545.674v530.792H24.803V155.549z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.803 155.549h545.674v530.792H24.803V155.549zM0 711.145h595.28V130.746H0v580.399zm348.487-336.086c0-2.977 0-10.169-1.24-24.06 0-1.984.496-2.48 1.984-3.224 15.13-6.201 51.095-17.114 91.276-17.114 1.984 0 2.977.496 2.977 2.48v35.717c0 1.984-.744 2.48-2.977 2.48-15.626-.744-38.693 1.24-47.374 4.96v156.51c0 1.984-.744 2.976-2.977 2.976h-38.941c-1.984 0-2.977-.744-2.977-2.976v-157.75h.249v.001zM164.943 535.784c-2.977 0-3.721-1.239-3.721-3.72V265.428c0-1.984.744-3.225 2.977-3.225h39.188c1.984 0 2.48.744 2.48 2.977v229.679h102.189c1.984 0 2.729.744 2.232 2.977l-6.2 35.221c-.496 1.983-1.736 2.976-3.721 2.976H164.943v-.249z",
    fill: "#aad1eb"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLightroom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lightroom.8f7f10fc.svg";
export { ForwardRef as ReactComponent };